import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import {AnyAction, Dispatch} from 'redux';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import CardCommissionAccountDetailView from '../../../components/views/mx/CardCommissionAccountDetailView';
import {
    CardCommissionAccountDetailsDispatchProps,
    CardCommissionAccountDetailsProps
} from '../../types/mx/containers';
import {CardCommissionAccountSummaryState} from '../../types/mx/types';
import {GROUP} from '../../constants/LabelConstants';
import {MODAL_TYPE} from '../../../constants/ModalConstants';

const mapStateToProps = (state: State, ownProps): CardCommissionAccountDetailsProps => {
    const cardCommissionAccountDetailsState: CardCommissionAccountSummaryState =
        !!ownProps.data && !!ownProps.data.cardCommissionAccountDetail ?
            ownProps.data.cardCommissionAccountDetail : {
                commissionCardId: '', cardNumber: '', cardHolderName: '',
                ownerName: '', ownerId: '', createdAt: {displayValue: '', value: 0},
                actFile: {url: ''}, identificationFile: {url: ''}, identificationGroupFile: {url: ''},
                cardBackupCodeFile: {url : ''}
            };
    return {
        commissionCardId: cardCommissionAccountDetailsState.commissionCardId,
        cardNumber: cardCommissionAccountDetailsState.cardNumber,
        cardHolderName: cardCommissionAccountDetailsState.cardHolderName,
        hideButtonDelete: ownProps.data.hideButtonDelete || false,
        actFile: cardCommissionAccountDetailsState.actFile ? {
            url: cardCommissionAccountDetailsState.actFile.url,
            mimeType: cardCommissionAccountDetailsState.actFile.mimeType,
            isUploaded: true
        } : null,
        identificationFile: cardCommissionAccountDetailsState.identificationFile ? {
            url: cardCommissionAccountDetailsState.identificationFile.url,
            mimeType: cardCommissionAccountDetailsState.identificationFile.mimeType,
            isUploaded: true
        } : null,
        identificationGroupFile: cardCommissionAccountDetailsState.identificationGroupFile ? {
            url: cardCommissionAccountDetailsState.identificationGroupFile.url,
            mimeType: cardCommissionAccountDetailsState.identificationGroupFile.mimeType,
            isUploaded: true
        } : null,
        cardBackupCodeFile: cardCommissionAccountDetailsState.cardBackupCodeFile ? {
            url: cardCommissionAccountDetailsState.cardBackupCodeFile.url,
            mimeType: cardCommissionAccountDetailsState.cardBackupCodeFile.mimeType,
            isUploaded: true
        } : null
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): CardCommissionAccountDetailsDispatchProps => {
    return {
        onCancel: () => dispatch(ModalActions.CLOSE_MODAL_ACTION.action()),
        onDelete: (commissionCardId: string) => {
            const headerModal = {
                title: GROUP.DELETE_CARD_COMMISSION_GROUP_TITLE
            };
            const contentModal = {
                type: MODAL_TYPE.CARD_COMMISSION_DELETE,
                data: {commissionCardId}
            };
            const optionsModal = {
                closeOnOverlayClick: false,
                size: 'large'
            };
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(headerModal, contentModal, null, optionsModal));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps
    };
};

const CardCommissionAccountDetailContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(CardCommissionAccountDetailView);

export default CardCommissionAccountDetailContainer;
